<template>
    <v-dialog v-model="show" width="80%" overlay-color="#000" persistent>
    <v-container fluid>
      <v-card color="black" elevation="0">
        <div class="text-end">
          <v-btn icon @click="cerrar">
            <v-icon size="35px" color="white">mdi-close</v-icon>
          </v-btn>
        </div>
        <div v-if="esImagen" class="d-flex justify-center align-center" style="height: 80vh;">
          <img :src="archivoBlob" style="max-height: 80vh; max-width: 100%; object-fit: contain;" />
        </div>
        <embed v-else :src="archivoBlob" type="application/pdf" width="100%" style="height: 80vh" />

      </v-card>
    </v-container>
  </v-dialog>
</template>

<script>

export default {

  props: {
    show: {
      type: Boolean,
      default: false
    },
    archivo: null,
    tipo: {
      type: String,
      default: 'application/pdf'
    }
  },
  data() {
    return {
      archivoBlob: null,
    }
  },
  computed: {
    esImagen() {
      if (this.tipo && typeof this.tipo === 'string' && this.tipo.startsWith('image/')) {
        return true;
      }
      if (typeof this.archivo === 'string') {
        if (this.archivo.startsWith('data:image/')) return true;
        if (/\.(png|jpe?g|gif|webp|svg)(\?.*)?$/i.test(this.archivo)) return true;
      }
      if (typeof this.archivoBlob === 'string') {
        if (this.archivoBlob.startsWith('data:image/')) return true;
      }
      return false;
    },
  },
  methods: {
    cerrar() {
      if (this.archivoBlob?.startsWith('blob:')) {
        URL.revokeObjectURL(this.archivoBlob);
      }
      this.$emit('cerrar');
    },
    conversion(dataURI) {
      // convert base64 to raw binary data held in a string
      // doesn't handle URLEncoded DataURIs - see SO answer #6850276 for code that does this
      let byteString = atob(dataURI.split(',')[1].replace(/\s/g, ''));

      // separate out the mime component
      let mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];

      // write the bytes of the string to an ArrayBuffer
      let ab = new ArrayBuffer(byteString.length);

      // create a view into the buffer
      let ia = new Uint8Array(ab);

      // set the bytes of the buffer to the correct values
      for (let i = 0; i < byteString.length; i++) {
        ia[i] = byteString.charCodeAt(i);
      }

      // write the ArrayBuffer to a blob, and you're done
      let blob = new Blob([ab], { type: mimeString });
      return blob;
    },
  },
  watch: {
    archivo: {
      immediate: true,
      handler(val) {
        if (!val) {
          this.archivoBlob = null;
          return;
        }

        // Caso 1: es blob url
        if (typeof val === 'string' && val.startsWith('blob:')) {
          this.archivoBlob = val;
          return;
        }

        // Caso 2: es URL http
        if (typeof val === 'string' && val.startsWith('http')) {
          this.archivoBlob = val;
          return;
        }

        // Caso 3: viene como data:...
        if (typeof val === 'string' && val.startsWith('data:')) {
          this.archivoBlob = val;
          return;
        }

        // Caso 4: base64 puro
        try {
          const defaultMime = this.tipo || 'application/pdf';
          const blob = this.conversion(`data:${defaultMime};base64,${val}`);
          this.archivoBlob = URL.createObjectURL(blob);
        } catch (error) {
          this.archivoBlob = null;
        }
      },
    },
  },
  // created() {
  //     this.archivoBlob = URL.createObjectURL(
  //         this.conversion(this.archivo)
  //     );

  // }
};
</script>

<style scoped>
::v-deep(.v-dialog) {
  border-radius: 0% !important;
}
</style>
